import Sucursal from "./Sucursal";
import { withRouter } from "react-router-dom";

export default withRouter(Sucursal);
